/**
 * VITE_PAYMENT_GATEWAY_URL tal cual en .env (sin barra final).
 * En producción es la URL pública del gateway.
 */
const RAW = (import.meta.env.VITE_PAYMENT_GATEWAY_URL || '').replace(/\/$/, '');

function isLocalPaymentHost(url: string): boolean {
  return /localhost|127\.0\.0\.1/.test(url);
}

/**
 * Base URL pública del gateway (logs, mensajes). Vacío si no está configurado.
 */
export function getPaymentGatewayPublicUrl(): string {
  return RAW;
}

/**
 * Base para `fetch()` desde el navegador.
 * En **desarrollo**, si apuntas a un gateway **HTTPS remoto** (p. ej. Railway), usamos el proxy
 * de Vite (`/__payment_gateway__`) para evitar CORS (mismo origen que localhost:8082).
 * Si la URL es localhost, en dev usamos `/__payment_dev__` (proxy a :3006) para Mini App / ngrok.
 * En **producción** siempre es la URL absoluta.
 */
export function getPaymentGatewayBrowserBase(): string {
  if (!RAW) {
    return import.meta.env.DEV ? '/__payment_dev__' : '';
  }
  if (import.meta.env.DEV && RAW.startsWith('https://')) {
    return '/__payment_gateway__';
  }
  if (import.meta.env.DEV && isLocalPaymentHost(RAW)) {
    return '/__payment_dev__';
  }
  return RAW;
}

/**
 * Base para `fetch()` cuando `VITE_PAYMENT_GATEWAY_URL` no está definido en desarrollo.
 */
export function getPaymentGatewayBrowserBaseWithDevFallback(): string {
  const base = getPaymentGatewayBrowserBase();
  if (base) return base;
  return import.meta.env.DEV ? '/__payment_dev__' : '';
}
